import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

const AutoComplete = ({ suggestions, onChange, value, refresh }) => {
    const [inputValue, setInputValue] = useState('');
    const [filteredSuggestions, setFilteredSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    useEffect(() => {
        const temp = suggestions?.find(x => x.idx === value);
        if (temp) {
            setInputValue(temp.title);
        } else {
            setInputValue('');
        }
    }, [suggestions, value]);

    const handleChange = e => {
        const userInput = e.target.value;
        setInputValue(userInput);

        const filtered = suggestions.filter(suggestion => suggestion.title.indexOf(userInput) > -1);

        setFilteredSuggestions(filtered);
        setShowSuggestions(true);
    };

    const handleClick = suggestion => {
        setInputValue(suggestion.title);
        setFilteredSuggestions([]);
        setShowSuggestions(false);
        onChange(suggestion);
    };

    return (
        <div className="autocomplete">
            {/* <input type="text" value={inputValue} onChange={handleChange} placeholder="검색어를 입력하세요" /> */}
            <Form.Control type={'text'} value={inputValue} onChange={handleChange} />
            {/* {showSuggestions && inputValue && (
                <ul className="suggestions" >
                    {filteredSuggestions.map((suggestion, index) => (
                        <li key={suggestion.idx} onClick={() => handleClick(suggestion)}>
                            {suggestion.title}
                        </li>
                    ))}
                </ul>
            )} */}
            {showSuggestions && inputValue && (
                <ul
                    className="suggestions"
                    style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        zIndex: 1000,
                        backgroundColor: 'white',
                        border: '1px solid #ddd',
                        borderTop: 'none',
                        listStyleType: 'none',
                        margin: 0,
                        padding: 0,
                        maxHeight: '200px',
                        overflowY: 'auto',
                    }}
                >
                    {filteredSuggestions.map((suggestion, index) => (
                        <li
                            key={index}
                            onClick={() => handleClick(suggestion)}
                            style={{
                                padding: '10px',
                                cursor: 'pointer',
                                hover: {
                                    backgroundColor: '#f0f0f0',
                                },
                            }}
                        >
                            {suggestion.title}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default AutoComplete;
